module.exports = __webpack_public_path__ + "static/media/Rectangle 408.e18703c1.png";